"use client";

import * as React from "react";

import { css, cva } from "@/../styled-system/css";

const input = cva({
  base: {
    py: "2.5",
    px: "3.5",
    rounded: "lg",
    borderWidth: "1px",
    borderColor: "gray.300",
    width: "100%",
    ringColor: "brandBlue",
    _file: {
      border: "none",
      bg: "transparent",
      textStyle: "sm",
      fontWeight: "medium",
    },
    _placeholder: {
      color: "gray.500",
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: "0.5",
    },
  },
});

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  css?: object;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ css: cssProp = {}, type, ...props }, ref) => {
    const className = css(input.raw(), cssProp);
    return <input type={type} className={className} ref={ref} {...props} />;
  },
);
Input.displayName = "Input";

export default Input;
